import React from "react";

export const TRADEMARK = "NavScora Admin™ is a trademark of Navscora Pty Ltd. All rights reserved.";

export const Footer = ({ className = "" }) => (
  <footer className={`mt-10 border-t border-[#1E2D4A] pt-4 pb-2 text-center text-[11px] text-slate-600 ${className}`} data-testid="app-footer">
    {TRADEMARK}
  </footer>
);
